export default "__VITE_ASSET__BXFatZkh__"